module.exports = __webpack_public_path__ + "img/blog_menu_pic12.f6866396.png";